
  class CreateReportingHierarchy {
    constructor($scope, $state, $timeout,USERSETTINGSCONSTANT,authService,localStorageService) {
      'ngInject';
      this.$state = $state
        //to store role data
      $scope.roleList = []
      $scope.subUsers = []
        //to store manager roles
      $scope.manager_role;
      $scope.subRoleList
      $scope.manager_user;
      $scope.isManager = false;
      $scope.isSubUser = false;
      $scope.school_id = localStorageService.get('school_id')
      $scope.reportingUsers = {}
      $scope.searchLeadRole = ""
      $scope.searchSubRole = ""
      $scope.searchItem = ""
      //to store userId's Bug #6241
      $scope.selectedSubUsers=[]
        //Role List
     authService.callAPI(USERSETTINGSCONSTANT.API_GET_HEAD_ROLES + $scope.school_id, "GET", {}, function (response) {    
      if(response.result && response.result.data && response.result.data.data)
       var result=response.result.data.data
        if (result) {
          $scope.roleList = result;
        }
        _.defer(function() {$scope.$apply();});
      })
  
      var HierarchyItems = function() {
  
        this.loadedPages = {};
  
  
        this.numItems = 0;
  
  
        this.PAGE_SIZE = 50;
  
        this.fetchNumItems_();
      };
  
  
      HierarchyItems.prototype.getItemAtIndex = function(index) {
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];
  
        if (page) {
          return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
          this.fetchPage_(pageNumber);
        }
      };
  
  
      HierarchyItems.prototype.getLength = function() {
        return this.numItems;
      };
  
      HierarchyItems.prototype.fetchPage_ = function(pageNumber) {
        var hierarchy=this
        hierarchy.loadedPages[pageNumber] = null;
        $timeout(angular.noop, 300).then(angular.bind(this, function() {
          hierarchy.loadedPages[pageNumber] = [];
          var pageOffset = pageNumber * this.PAGE_SIZE;
          let paginationOpts = {
            limit: parseInt(this.PAGE_SIZE),
            skip: parseInt(pageOffset),
          };
          if (!$scope.searching) {
            if ($scope.isSubUser) {
              var roleId = $scope.selectedSubRole._id
              let selectedList = !$scope.selectedSubUsers ? [] : $scope.selectedSubUsers
              var reqObj={
                  selector:{
                    role_ids: roleId,
                    school_id: $scope.school_id,
                    _id: {
                      $nin: [$scope.manager_user._id]
                    }
                  },
                  role_id:roleId,
                  selected_list:selectedList,
                  head_role:$scope.manager_role.role_id,
                  pagination_opts:paginationOpts,
                  user_id:$scope.manager_user._id
              }
              authService.callAPI(USERSETTINGSCONSTANT.API_GET_SUB_USERS, "POST", reqObj, function (response) {    
                if(response.result  && response.result.data &&response.result.data.data)
                {
                  var result=response.result.data.data
                  if (result) {
                    hierarchy.loadedPages[pageNumber] = result
                    
                  }
                  if (result  && result.length>0) {
                    if(result[0].selected_list)
                    $scope.selectedSubUsers = result[0].selected_list
                    
                  }
                }
                
                $scope.$apply()
              })
            } else {
                 var reqObj={
                  selector:{
                    role_ids: $scope.current_role,
                    school_id: $scope.school_id,
                  },
                  role_id:$scope.current_role,
                  pagination_opts:paginationOpts
                 
              }
                authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERS, "POST", reqObj, function (response) {    
                if(response.result  && response.result.data &&response.result.data.data)
                var result=response.result.data.data
                if (result.length > 0) {
                  hierarchy.loadedPages[pageNumber] = result
                  $scope.$apply()
                }
              })
            }
          } else {
            if ($scope.isSubUser) {
              var roleId = $scope.selectedSubRole._id
              var selectedList = !$scope.selectedSubUsers ? [] : $scope.selectedSubUsers
              var reqObj={
                selector:{
                  role_ids: roleId,
                  school_id: $scope.school_id,
                  name:$scope.searchSubItem,
                  _id: {
                    $nin: [$scope.manager_user._id]
                  }
                },
                role_id:roleId,
                selected_list:selectedList,
                head_role:$scope.manager_role.role_id,
                pagination_opts:paginationOpts,
                user_id:$scope.manager_user._id
            }
            authService.callAPI(USERSETTINGSCONSTANT.API_GET_SUB_USERS, "POST", reqObj, function (response) {    
              if(response.result  && response.result.data &&response.result.data.data)
              {
                var result=response.result.data.data
                if (result) {
                  hierarchy.loadedPages[pageNumber] = result
                  
                }
                if (result  && result.legth>0) {
                  if(result[0].selected_list)
                  $scope.selectedSubUsers = result[0].selected_list
                  
                }
              }
              
              $scope.$apply()
            })
            } else {
                var reqObj={
                    selector:{
                      role_ids: $scope.current_role,
                      school_id: $scope.school_id,
                      name:$scope.searchItem,
                    },
                   
                    role_id:$scope.current_role,
                    pagination_opts:paginationOpts
                   
                }
            authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERS, "POST", reqObj, function (response) {    
              if(response.result  && response.result.data &&response.result.data.data)
              var result=response.result.data.data
              if (result.length > 0) {
                  hierarchy.loadedPages[pageNumber] = result
                  $scope.$apply()
                }
              })
            }
          }
  
  
  
        }));
      };
  
      HierarchyItems.prototype.fetchNumItems_ = function() {
        var hierarchy = this 
        $timeout(angular.noop, 300).then(angular.bind(this, function() {
          if (!$scope.searching) {
            if ($scope.isSubUser) {
                var reqObj={
                    role_ids: $scope.current_role,
                    school_id: $scope.school_id,
                }
            authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {     
              //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, (error, result) => {
                if(response.result  && response.result.data &&response.result.data.data)
              {
              var result=response.result.data.data
              if (result) {
                  var index = $scope.selectedManagerUser.role_ids.indexOf($scope.current_role);
                  if (index > -1)
                  hierarchy.numItems = result - 1
                  else
                  hierarchy.numItems = result
                  $scope.$apply();
                }
              }
  
              })
            } else {
                var reqObj={
                    role_ids: $scope.current_role,
                    school_id: $scope.school_id,
                }
            authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {     
              if(response.result  && response.result.data &&response.result.data.data)
              {
              var result=response.result.data.data
              //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, (error, result) => {
                if (result) {
                  hierarchy.numItems = result
                  $scope.$apply();
                }
              }
              })
            }
          } else {
            if ($scope.isSubUser) {
                //let regex = new RegExp( $scope.searchSubItem, 'i' );
                var reqObj={
                    role_ids: $scope.current_role,
                    school_id: $scope.school_id,
                    name:$scope.searchSubItem
                }
            authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {     
              if(response.result  && response.result.data &&response.result.data.data)
              { 
              var result=response.result.data.data
                //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, $scope.searchSubItem, (error, result) => {
                if (result) {
                  hierarchy.numItems = result
                  $scope.$apply();
                }
              }
  
              })
            } else {
                var reqObj={
                    role_ids: $scope.current_role,
                    school_id: $scope.school_id,
                    name:$scope.searchItem
                }
            authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {     
              if(response.result  && response.result.data &&response.result.data.data)
              {
               
              var result=response.result.data.data
              //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, $scope.searchItem, (error, result) => {
                if (result) {
                  hierarchy.numItems = result
                  $scope.$apply();
                }
              }
              })
            }
          }
  
        }));
      };
  
  
      $scope.loadMangerUsers = (role) => {
        $scope.isManager = true;
        $scope.isSubUser = false;
        $scope.current_role = role._id;
        $scope.manager_role = {
          "role_id": role._id,
          "role": role.name
        };
        $scope.searching = false;
        $scope.managerUsers = new HierarchyItems();
        $scope.subRoleList = []
        $scope.subUsers = undefined
        $scope.selectedManagerRole = role;
        $scope.reportingUsers = {}
      }
      $scope.loadSubRoles = (user) => {
        $scope.subUsers = undefined
        $scope.manager_user = {
          "name": user.name,
          "_id": user._id
        }
        var reqObj = {
          head_id:$scope.manager_role.role_id,
          school_id:$scope.school_id,
          user_id: user._id
        }
        authService.callAPI(USERSETTINGSCONSTANT.API_GET_SUB_ROLES, "POST", reqObj, function (response) {  
          if(response.result && response.result.data && response.result.data.data)
            var result =response.result.data.data    
          //Meteor.call("getSubRoles", $scope.manager_role.role_id, user._id, $scope.school_id, (error, result) => {
            $scope.subRoleList = result
            
            $scope.$apply()
          })
        
        $scope.selectedManagerUser = user
        $scope.reportingUsers = {}
      }
      $scope.loadSubUsers = (role) => {
        $scope.selectedSubUsers=[]
        $scope.isManager = false;
        $scope.isSubUser = true;
        $scope.current_role = role._id;
        $scope.sub_role = {
          "role_id": role._id,
          "role": role.name
        };
        $scope.searching = false;
        $scope.subUsers = new HierarchyItems();
        $scope.selectedSubRole = role
      }
      $scope.saveReportingRoles = () => {
        if (Object.keys($scope.reportingUsers).length > 0) {
          //$scope.reportingUsers.parent_id=$scope.manager_user._id
          let reqObj={
            "reporting_users":angular.copy($scope.reportingUsers),
            "school_id":$scope.school_id,
            "academic_year":localStorage.getItem('activeAcdYear'),
            "head_id":$scope.manager_user._id,
            "headrole_id":$scope.manager_role.role_id
          }
         authService.callAPI(USERSETTINGSCONSTANT.API_SAVE_USER_MAPPING, "POST", reqObj, function (response) { 
          if (response.result.data.message=="Success") {
              toastr.success("Saved Successfully")
              $state.go("reportingRoles")
              $scope.$apply()
            } else
              toastr.success("Please try again")
          })
        } else {
          toastr.error("Please add before saving")
        }
  
      }
      $scope.cancel = () => {
        $state.go("reportingRoles")
      }
      $scope.mapRoles = () => {
        $state.go("roleMapping")
      }
      $scope.addReportingRoles = () => {
        var roleId = $scope.selectedSubRole._id
        let dataArray = []
          var data = $scope.selectedSubUsers
          for (var i = 0; i < data.length; i++) {
            let item = {
              "role_id": roleId,
              "role": $scope.selectedSubRole.name,
              "name": data[i].name,
              "_id": data[i]._id,
              "isSelected": data[i].isSelected,
              "parent_id": $scope.selectedManagerUser._id,
              "parent_name": $scope.selectedManagerUser.name,
              "parent_role_id": $scope.selectedManagerRole._id,
              "parent_role": $scope.selectedManagerRole.name
            }
            dataArray.push(item);
          }
        var users = _.filter(dataArray, function(obj) {
          return obj.isSelected === true
        })
        $scope.reportingUsers[roleId] = users
      }
       $scope.addToSelectedSubRole = (data) => {
         var roleId = $scope.selectedSubRole._id
        if(data.isSelected)
        {
         let item = {
              "role_id": roleId,
              "role": $scope.selectedSubRole.name,
              "name": data.name,
              "_id": data._id,
              "isSelected": data.isSelected,
              "parent_id": $scope.selectedManagerUser._id,
              "parent_name": $scope.selectedManagerUser.name,
              "parent_role_id": $scope.selectedManagerRole._id,
              "parent_role": $scope.selectedManagerRole.name
            }
          $scope.selectedSubUsers.push(item)
        }
        else
        {
          if($scope.selectedSubUsers.length>0){
            //Fixed issue #6316
            let index=$scope.selectedSubUsers.findIndex(i=>i._id==data._id)
            if(index>-1)
              $scope.selectedSubUsers.splice(index,1)
          }
        }
       }
      
      $scope.searchLeadAmongResult = (flag) => {
        if(flag==0)
        $scope.searching = true;
        else
        $scope.searching = false;
        $scope.isManager = true;
        $scope.isSubUser = false;
        $scope.current_role = $scope.selectedManagerRole._id;
        $scope.managerUsers = new HierarchyItems();
        $scope.subRoleList = []
      }
      $scope.searchSubAmongResult = (flag) => {
        if(flag==0)
        $scope.searching = true;
        else
        $scope.searching = false;
        $scope.subUsers = undefined
        $scope.isManager = false;
        $scope.isSubUser = true;
        $scope.current_role = $scope.sub_role.role_id;
       
        $scope.subUsers = new HierarchyItems();
      }
  
    }
  }
  export default CreateReportingHierarchy



// WEBPACK FOOTER //
// ./src/app/reporting-roles/controllers/userSettingsController.js